import i18n from '../i18n';

export const BATCH_LOCK_NOTES = {
    get branch() {
        return i18n.t('batches.lockNotes.branch');
    },
    get level() {
        return i18n.t('batches.lockNotes.level');
    },
    get carryForward() {
        return i18n.t('batches.lockNotes.carryForward');
    },
    get chargesMode() {
        return i18n.t('batches.lockNotes.chargesMode');
    },
    get monthlyYearly() {
        return i18n.t('batches.lockNotes.monthlyYearly');
    },
    get systemManaged() {
        return i18n.t('batches.lockNotes.systemManaged');
    },
    get sessionCharge() {
        return i18n.t('batches.lockNotes.sessionCharge');
    },
};

/** @param {'branch'|'level'|'coach'|'name'|'sessionMode'|'schedule'|'chargesMode'|'sessionCharge'|'carryForward'|'periodCharge'} field */
export function canEditBatchField(field, { isEdit, hasActivity, systemManaged }) {
    if (systemManaged) return false;
    if (!isEdit) return true;
    switch (field) {
        case 'branch':
        case 'level':
            return false;
        case 'carryForward':
        case 'periodCharge':
        case 'chargesMode':
            return !hasActivity;
        default:
            return true;
    }
}

export function buildBatchUpdateBody(form, { isEdit, hasActivity }) {
    const carryForwardMode = form.chargesMode === "PER_PERIOD"
        ? "NOT_ALLOWED"
        : (form.carryForwardMode || "NOT_ALLOWED");

    const body = {
        coachId: form.coachId ? Number(form.coachId) : null,
        name: form.name,
        deliveryMode: form.sessionMode || 'ANY',
        sessionDays: form.sessionDays,
        defaultStartTod: form.defaultStartTod || null,
        defaultEndTod: form.defaultEndTod || null,
        sessionCharge: form.sessionCharge ? Number(form.sessionCharge) : null,
    };

    if (!isEdit) {
        return {
            ...body,
            branchId: form.branchId ? Number(form.branchId) : null,
            levelId: form.levelId ? Number(form.levelId) : null,
            chargesMode: form.chargesMode || 'PER_SESSION_HOURLY',
            periodInterval: form.periodInterval || 'MONTHLY',
            periodCharge: form.periodCharge ? Number(form.periodCharge) : null,
            carryForwardMode,
        };
    }

    if (!hasActivity) {
        body.chargesMode = form.chargesMode || 'PER_SESSION_HOURLY';
    }

    body.levelId = form.levelId ? Number(form.levelId) : null;
    body.carryForwardMode = carryForwardMode;
    if (form.periodInterval) {
        body.periodInterval = form.periodInterval;
    }
    if (form.periodCharge !== '' && form.periodCharge != null) {
        body.periodCharge = Number(form.periodCharge);
    }

    return body;
}
